import React from 'react';
import { useTranslation } from 'react-i18next';

const TestiBox = ({ className = '' }) => {
  const { t } = useTranslation();
  const testimonials = t('sections.testimonialCard.testimonials', { returnObjects: true, defaultValue: [
    {
      title: 'Sarah Rahman',
      subtitle: 'UX Designer',
      text: 'We were struggling to manage our growing cloud infrastructure and protect our sensitive data. Securs expert team provided us with a comprehensive security solution that not only met our needs but exceeded our expectations. Their proactive detection.',
      rating: 5.0,
      ratingCount: 1,
      img: 'assets/img/testimonial/1-3.png'
    }
  ] });

  return (
    <>
      {testimonials.map((testimonial, index) => (
        <div className={className} key={index}>
          <div className="testi-card style2">
            <div className="box-thumb">
              <img src={testimonial.img || testimonial?.image || testimonial?.img} alt={testimonial.title || testimonial.name || 'testimonial'} />
            </div>
            <h3 className="box-title">{testimonial.title || testimonial.name}</h3>
            <span className="box-subtitle">{testimonial.subtitle || testimonial.designation}</span>
            <div className="testi-card-content">
              <p className="box-text">{testimonial.text}</p>
            </div>
            <div className="star-rating" role="img" aria-label={t('sections.testimonialCard.rating_aria',{rating: testimonial.rating || testimonial.ratingCount || '5'})}>
              <span>
                {t('sections.testimonialCard.rating_text',{rating: testimonial.rating || testimonial.ratingCount || '5', count: testimonial.ratingCount || 1})}
              </span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default TestiBox;